class SliderBrandsVertical {
    constructor(item) {
        // Переменные
        this.element = item;
        this.slider = this.element.querySelector('.js-slider');
        this.btnPrev = this.element.querySelector('.js-slider-prev');
        this.btnNext = this.element.querySelector('.js-slider-next');
        this.swiper;

        // Функции
        this.setListeners();
    };

    setListeners() {
        if (window.innerWidth < 1280) {
            this.swiper = new Swiper(this.slider, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation: {
                    nextEl: this.btnNext,
                    prevEl: this.btnPrev,
                },
            });
        } else {
            this.swiper = new Swiper(this.slider, {
                direction: 'vertical',
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation: {
                    nextEl: this.btnNext,
                    prevEl: this.btnPrev,
                },
            });
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth < 1280) {
                this.swiper.changeDirection('horizontal');
            } else {
                this.swiper.changeDirection('vertical');
            }
        });
    }
};

document.querySelectorAll('.js-slider-brands-vertical').forEach((item) => new SliderBrandsVertical(item));
